import React, { useState, Suspense } from 'react';
import { FirestoreCollection } from '@react-firebase/firestore';
import { Helmet } from 'react-helmet-async';

import HomeHeader from '../../Components/HomeHeader/HomeHeader';
import Solutions from '../../Components/Solutions/Solutions';
import Testimonials from '../../Components/Testimonials/Testimonials';
import HowDoWeDo from '../../Components/HowDoWeDo/HowDoWeDo';
import GlobalInfoSection from '../../Components/GlobalInfoSection/GlobalInfoSection';
import WhoWeAre from '../../Components/WhoWeAre/WhoWeAre';
import Expertise from '../../Components/Expertise/Expertise';
import ProjectPlanner from '../../Components/ProjectPlanner/ProjectPlanner';
import ContactUsModal from '../../Components/ContactUsModal/ContactUsModal';
import LoadingSection from '../../Components/LoadingSection/LoadingSection';
import { useSessionStorage } from '../../hooks/useSessionStorage';

const MapLazy = React.lazy(() => import('../../Components/Map/Map'));

export default function Home() {
	const [contactModal, setContactModal] = useState(false);
	const [language] = useSessionStorage('language', '');

	return (
		<FirestoreCollection path="/homePage/">
			{(data) => {
				return data.isLoading ? (
					<LoadingSection />
				) : (
					<div className="homePage">
						<Helmet>
							{data.value[0].homeHeader.metaDescription && (
								<meta name="description" content={data.value[0].homeHeader.metaDescription} />
							)}
							{data.value[0].homeHeader.metaKeywords && (
								<meta name="keywords" content={data.value[0].homeHeader.metaKeywords} />
							)}
						</Helmet>
						<HomeHeader {...data.value[0].homeHeader} />
						<Solutions {...data.value[0].solutions} />
						{language !== 'ua' && <Testimonials {...data.value[0].clientReviews} />}
						<HowDoWeDo {...data.value[0].howWeDoIt} />
						<FirestoreCollection path="/expertise/">
							{(data) => {
								if (data.isLoading) {
									return;
								}
								return (
									<Expertise
										{...data.value[0].expertise}
										headTitleUa={data.value[0].headTitleUa}
										headTitle={data.value[0].headTitle}
									/>
								);
							}}
						</FirestoreCollection>
						{language !== 'ua' && <GlobalInfoSection scrollToPlanner {...data.value[0].riskManagement} />}
						<Suspense fallback={<LoadingSection height={800} />}>
							<FirestoreCollection path="/map/">
								{(mapData) => {
									if (mapData.isLoading) {
										return;
									}
									return <MapLazy setContactModal={setContactModal} {...mapData.value[0]} />;
								}}
							</FirestoreCollection>
						</Suspense>
						<WhoWeAre {...data.value[0].whoWeAre} />
						<GlobalInfoSection {...data.value[0].newTalent} />
						<ProjectPlanner {...data.value[0].projectPlanner} />
						<ContactUsModal contactModal={contactModal} setContactModal={setContactModal} />
					</div>
				);
			}}
		</FirestoreCollection>
	);
}
